import { toastNotifications } from '@uag/react-core';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetAutomatedPanelPlacement } from 'app/modules/wallforming/components/setting-container/hooks/useGetAutomatedPanelPlacement';

export const useHandlePanelPlacement = () => {
    const { t } = useTranslation();

    const [isAutomatedPanelPlacementLoading, setIsAutomatedPanelPlacementLoading] = useState<boolean>(false);

    const runAutomatedPanelPlacement = useGetAutomatedPanelPlacement({
        setLoadingState: setIsAutomatedPanelPlacementLoading
    });

    const handlePanelPlacementStart = useCallback(() => {
        if (isAutomatedPanelPlacementLoading) {
            return;
        }

        toastNotifications.information({ title: t('info'), message: t('infoLoadingAutoPanelPlacement') });
        void runAutomatedPanelPlacement();
    }, [isAutomatedPanelPlacementLoading, runAutomatedPanelPlacement, t]);

    return { handlePanelPlacementStart, isAutomatedPanelPlacementLoading };
};
